import React, {useState, useEffect, useRef} from 'react'
import './comparatore.css';
import { FaArrowRight, FaGraduationCap } from 'react-icons/fa';
import comp1 from '../imgs/comp1.png';
import {useNavigate} from 'react-router-dom'
import dataCorsi from './output.json';
import icon from '../imgs/Vector.png';
import { useSearch } from '../context/SearchContext';
import compmob1 from '../imgs/comp-mob1.png';
import axios from 'axios';
import {
  getTrackingId,
  mapCourseType,
  SOURCE_SITE,
  trackClickCta,
  trackGenerateLead,
  trackLeadError,
} from '../tracking';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { provinces } from './atenei';



const getCourseNameForUTM = (degreeType) => {
  const courseMapping = {
    "cs": "Cybersecurity",
    "fullstack": "Sviluppo Software e Web Development", 
    "Data Analyst": "Data Analyst",
    "Data Science": "Data Science",
    "ai": "Intelligenza Artificiale",
    "Python": "Python and Machine Learning",
    "Game Developer": "Game Developer",
    "Ux-Ui": "Ux/Ui",
    "DigitalMktg": "Digital Marketing",
    "SocialMedia": "Social Media Management",
    "pm": "Project Management",
    "BIM": "BIM & Autocad",
    "amministrativi": "Lavori Amministrativi",
    "Interior Design": "Interior Design",
    "Graphic Design": "Graphic Design",
    "Video Editing": "Video Editing"
  };
  
  return courseMapping[degreeType] || degreeType;
};


const AutocompleteCustom = ({ items, value, onChange, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const wrapperRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e);
    setIsOpen(true);
  };

  const handleSelect = (item) => {
    onSelect(item);
    setIsOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      setHighlightedIndex((prevIndex) => (prevIndex + 1) % items.length);
    } else if (e.key === 'ArrowUp') {
      setHighlightedIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
    } else if (e.key === 'Enter') {
      handleSelect(items[highlightedIndex]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
 
  const isMobile = () => {
    return window.innerWidth <= 768;
  };

  return (
    <div ref={wrapperRef} style={{ position: 'relative', width: '100%' }}>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder="Digita il nome della provincia"
        style={{
          padding: '12px 20px',
          borderRadius: '7px',
          fontSize: '16px',
          border: value === "" ? '1px solid #00000050' : '1.3px solid #FF6600',
          margin: '0 0px',
          width: isMobile() ? '90%' : '90%',
          fontFamily: "'Poppins', sans-serif",
          outline: 'none',
          backgroundColor: '#fff',
          boxShadow: value === "" ? 'none' : "0 0 10px 2px #F37E0E70"
        }}
      />
      {isOpen && (
        <div style={{
          borderRadius: '3px',
          padding: '10px 0px',
          fontSize: '100%',
          backgroundColor: 'transparent',
          width: '87%',
          border: '1px solid #00000050',
          overflowY: 'scroll',
          position: 'absolute',
          zIndex: '1',
          fontFamily: 'Poppins, Sans-Serif',
          maxHeight: isMobile() ? '300px' : '300px',
        }}>
          {items.map((item, index) => (
            <div
              key={item}
              onClick={() => handleSelect(item)}
              style={{
                background: index === highlightedIndex ? 'lightgray' : 'white',
                cursor: 'pointer',
                padding: '5px 10px',
                border: '1px solid #00000050',
              }}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const PrezziSlider = ({ min, max, step, onChange, rangeMax }) => {
    const [value, setValue] = useState([min, rangeMax]);
  
    const handleSliderChange = (newValue) => {
      setValue([min, newValue[1]]);
      onChange([min, newValue[1]]);
    };
  
    return (
      <div className='barra-prezzi' id='price-slider'>
        <div id='price-display' className='price-range-max'  style={{ position: 'relative',   left: value[1] === 1000 ? '20%' : `${((value[1] - min) / (max - min)) * 100}%`, 
        transform: 'translateX(-50%)' }}>
            {value[1]}€
          </div>
        <Slider
          id='budget-range'
          min={min}
          max={max}
          step={step}
          range
          value={value}
          onChange={handleSliderChange}
          className="custom-slider-prezzo"
        />
      </div>
    );
  };

const ComparatoreLeadSystem = () => {
    const { degreeType, setDegreeType, desiredDegree, setDesiredDegree, subjectOfInterest, setSubjectOfInterest, 
        budget, setBudget, lastName, setLastName, firstName, setFirstName, email, setEmail, phone, setPhone, enrollmentTime,
        setEnrollmentTime, universityStatus, setUniversityStatus, workStatus, setWorkStatus, studyTime, setStudyTime, categories,
        setCategories, origBudget, setOrigBudget, origDegreeType, setOrigDegreeType, origDesiredDegree, setOrigDesiredDegree, origSubjectOfInterest, setOrigSubjectOfInterest, necessità, setNecessità
      , rangeMax, setRangeMax, città, setCittà, } = useSearch();

    const navigate = useNavigate();
    const [accept, setAccept] = useState(false);
    const [acceptTreatment, setAcceptTreatment] = useState(false);
    const [filteredProvinces, setFilteredProvinces] = useState(provinces);
    const [utmCampaign, setUtmCamp] = useState("");
    const [utmSource, setUtmSrc] = useState("");
    const [utmMedium, setUtmMedium] = useState("");
    const [utmTerm, setUtmTerm] = useState("");
    const [utmAdset, setUtmAdset] = useState("");
    const [utmAdgroup, setUtmAdgroup] = useState("");
    const [sourceSite, setSourceSite] = useState("");
    const [trackingId, setTrackingId] = useState("");
    const storedLead = localStorage.getItem('lead');
    if (storedLead !== null) {
      const leadData = JSON.parse(storedLead);
    } else {
      console.log("Nessun dato lead trovato in localStorage.");
    }


const prezzoMin = 500;
const [prezzoMax, setPrezzoMax] = useState(1500);
  
    const handleChangePrezzo = (nuoviValori) => {
      setPrezzoMax(nuoviValori[1]);
      setRangeMax(nuoviValori[1]);
    };

    useEffect(() => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  script.async = true;
  document.head.appendChild(script);
}, []);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
    
        const utmSource = searchParams.get('utm_source');
        const utmCampaign = searchParams.get('utm_campaign');
        const utmContent = searchParams.get('utm_medium');
        const utmTerm = searchParams.get('utm_term');
        const utmAdgroup = searchParams.get("utm_adset");
        const utmAdset = searchParams.get("utm_ad");
        const sourceSiteParam = searchParams.get('source_site');
        const trackingIdParam = searchParams.get('tracking_id');
        const corsoParam = searchParams.get('corso');
    
        setUtmCamp(utmCampaign);
        setUtmSrc(utmSource);
        setUtmMedium(utmContent);
        setUtmTerm(utmTerm)
        setUtmAdset(utmAdset);
        setUtmAdgroup(utmAdgroup);
        setSourceSite(sourceSiteParam || "");
        setTrackingId(trackingIdParam || "");

        console.log(utmSource, utmContent, utmCampaign, utmTerm, utmAdgroup, utmAdset, sourceSiteParam, trackingIdParam, corsoParam);
        setRangeMax(1500)

        if (corsoParam) {
          const corsoValue = decodeURIComponent(corsoParam).trim();
          setDegreeType(corsoValue);
          setOrigDegreeType(corsoValue);
        }
      }, []);
  
    const handleChange = (e, setter) => {
      setter(e.target.value);
    };
    const handleUniversityStatusChange = (e) => {
        setUniversityStatus(e);
      };
      const [handlePosition, setHandlePosition] = useState(-110);
    
      const handleWorkStatusChange = (e) => {
        setWorkStatus(e);
      };

      const handleSendSheet = async () => {
        const urlSheet = 'https://sheet.best/api/sheets/2b48a2f8-bc37-4c32-9927-390557b57bd2';
        const checkUrl = `${urlSheet}?search=email:${email}`; 
        const formData = {
          Data: new Date(),
          nome: firstName,
          cognome: lastName,
          email: email,
          ["Percorso di studi"]: desiredDegree,
          ["Campagna UTM"]: utmCampaign,
          ["Source UTM"]: utmSource,
          ["Content UTM"]: utmMedium,
          Cellulare: phone,
          ["Keywords UTM"]: utmTerm,
          ["Adgroup UTM"]: utmAdgroup,
          ["Adset UTM"]: utmAdset,
        };

        const checkResponse = await fetch(checkUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });
      
          const existingData = await checkResponse.json();
          const matchingData = existingData.filter(item => item.email === email);

          if (matchingData.length > 0) {
            console.log('I dati con questa email esistono già. Non è possibile inviare duplicati.', matchingData);
            //navigate('/universita/risultati', { state: { showLoad: true }});
            return; 
          }
      
        await fetch(urlSheet, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
      
            if (response.ok) {
              console.log("Dati inviati con successo");
              setIsLoad(false);
             // navigate('/cs/risultati', { state: { showLoad: true }});
            } else {
              console.error("Errore nell'invio dei dati");
            }
          })
          .catch((error) => {
            console.error("Errore:", error);
          });
      };

      const [isLoad, setIsLoad] = useState(false);

  
const handleSendLead = async () => {
  // Crea utm_content dinamico basato sul corso selezionato
  const dynamicUtmContent = `Comparatore ${getCourseNameForUTM(degreeType)}`;
  
  const formData = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      phone: phone,
      lavoro: workStatus,
      universita: universityStatus,
      eta: studyTime,
      corsoDiLaurea: desiredDegree || getCourseNameForUTM(degreeType),
      facolta: subjectOfInterest || 'Non specificata',
      utmCampaign: utmCampaign,
      utmSource: utmSource,
      utmContent: dynamicUtmContent, // ← Ora dinamico invece di 'Comparatore Generico'
      utmTerm: utmTerm,
      categories: categories,
      enrollmentTime: enrollmentTime,
      budget: rangeMax.toString(),
      utmAdgroup: utmAdgroup,
      utmAdset: utmAdset,
      tipologiaCorso: degreeType,
      città: città,
      necessità: necessità,
      source_site: sourceSite || SOURCE_SITE,
      tracking_id: getTrackingId(),
  }

  try {
    const response = await axios.post(process.env.REACT_APP_API_URL + '/api/comparacorsi/comparatore-webhook-generale', formData);
    console.log('Risposta dal server:', response.data);
    trackGenerateLead({
      courseType: mapCourseType(categories, degreeType),
      userData: { email, phone, firstName, lastName },
    });
    localStorage.setItem('lead', JSON.stringify(formData))
  } catch (error) {
    console.error('Errore durante la richiesta al server:', error);
    trackLeadError(error.response?.status || error.message || 'network_error');
    setIsLoad(false);
  }
};

      const [missingField, setMissingField] = useState([]);

      const checkFields = () => {
        let missingField = []
        if (firstName === "") missingField.push("Nome");
        if (lastName === "") missingField.push("Cognome");
        if (email === "") missingField.push("Email");
        if (phone === "") missingField.push("Numero di telefono");
        if (categories === "") missingField.push("Categorie");
        if (necessità === "") missingField.push("Necessità");   
        if (degreeType === "") missingField.push("Corso di interesse"); // ✅ AGGIUNGI QUESTA 

        
        if (città === "") missingField.push("Città");
   
   
     
        if (!accept) missingField.push("Accetta i termini e le condizioni");
    
        if (missingField.length > 0) {
            setMissingField(missingField);
            alert(`Compila i campi: ${missingField.join(", ")}`);
            trackLeadError(`validation_missing_fields:${missingField.join(',')}`);
            setIsLoad(false);
            return false;
        }
    
        return true;
    };
      const handleSubmit = () => {
        setIsLoad(true)
        if (!checkFields()) {
          return;
        } else if (!isValidMobileNumber(phone)){
            alert('Inserisci un numero valido');
            setMissingField("Numero di telefono");
            trackLeadError('validation_invalid_phone');
            setIsLoad(false);
            setPhone("");
            return
        } else if (!isValidEmail(email)){
            alert('Inserisci una mail valida');
            setMissingField("Email");
            trackLeadError('validation_invalid_email');
            setIsLoad(false);
            setEmail("");
            return
        } else if (!provinces.includes(città)){
          alert("Inserisci una provincia valida")
          trackLeadError('validation_invalid_province');
          setIsLoad(false)
          return
        }
          try {
          trackClickCta('comparatore', 'body');
          handleSendLead();
          handleSendSheet();

          // 🔁 Redirect dinamico
          const slug = degreeType.toLowerCase().replace(/\s|&/g, '-'); // es: "Cybersecurity" → "cybersecurity"
          navigate(`/risultati`, { state: { showLoad: true } });

        } catch (error) {
           console.error(error);
           trackLeadError(error.response?.status || error.message || 'network_error');
           setIsLoad(false)
        }
      };

      const [uniqueArea, setUniqueArea] = useState([]);
      const [uniqueCorso, setUniqueCorso] = useState([]);
      const [uniquePrice, setUniquePrice] = useState([]);

      useEffect(() => {
        const filteredAreaNames = [...new Set(dataCorsi.filter(data => data.Tipologia === degreeType).map(data => data.Area))];
        setUniqueArea(filteredAreaNames);
        setDesiredDegree("");
        setSubjectOfInterest("");
        setBudget("");
      }, [degreeType]);

      useEffect(() => {
        const filteredCorsoNames = [...new Set(dataCorsi.filter(data => data.Tipologia === degreeType && data.Area === desiredDegree).map(data => data['Corsi di laurea + (non lo so)']))];
        setUniqueCorso(filteredCorsoNames)
        setSubjectOfInterest("");
        setBudget("");
      }, [desiredDegree]);

      useEffect(() => {
        const filteredBudgetNames = [...new Set(dataCorsi.filter(data => data.Tipologia === degreeType && data.Area === desiredDegree).map(data => data['Costo ']))];
        setUniquePrice(filteredBudgetNames);
        setBudget("");
      }, [subjectOfInterest]);

      const isValidEmail = (email) => {
        const emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)(?!.*\.\.)[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}$/;
      
        return emailRegex.test(email);
      };

      const isValidMobileNumber = (phoneNumber) => {
        const mobileNumberRegex = /^[0-9]{10}$/;
      
        return mobileNumberRegex.test(phoneNumber);
      };

      const isMobile = () => {
        return window.innerWidth <= 768;
      };

       const handleChangeProvincia = (event) => {
        console.log(event)
        const inputValue = event.target.value;
        setCittà(inputValue);
    
        // Filtra le province che includono il testo inserito dall'utente
        const filtered = provinces.filter(province =>
          province.toLowerCase().includes(inputValue.toLowerCase())
        );
        setFilteredProvinces(filtered);
      };

      const [showFullText, setShowFullText] = useState(false);

  return (
    <div className='comparatore'>
        <div className='comparatore-top'>
            <div>
                {!isMobile() && <img alt='icon' src={icon} />}
                <h2 style={{fontWeight: '400', lineHeight: '28px'}}>Confronta i <b>migliori corsi di formazione</b> online</h2>
            </div>
            <div>
                <img alt='sequenza comparatore' src={comp1} />
            </div>
        </div>
        <h1 className='h1-comp'>In pochi click trovi il <b>tuo corso ideale</b> al <font color='#FF6600'><b>costo più basso</b></font> garantito.</h1>
        
     
        <div  class="trustpilot-widget" data-locale="it-IT" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="64b965467cc49ff7fef5cd54" data-style-height="24px" data-style-width="100%">
          <a href="https://it.trustpilot.com/review/comparacorsi.it" target="_blank" rel="noopener">Trustpilot</a>
        </div>
        <hr className='separatore' />
        <div className='comparatore-domande' id='form-comparatore-old'>
            <div className='domanda'>
              <label>Quale corso ti interessa?</label>
              <select
                id='course-type-select'
                className={`${degreeType !== "" ? 'filled' : missingField.includes("Tipo di laurea") ? 'campo-mancante' : ''}`} 
                value={degreeType} 
                onChange={(e) => {
                  handleChange(e, setDegreeType);
                  handleChange(e, setOrigDegreeType);
                }} 
                required
              >
                <option value="" disabled>-- Seleziona un corso --</option>
                <option value="cs">Cybersecurity</option>
                {/* <option value="fullstack">Full Stack Development</option>
                <option value="Data Analyst">Data Analyst</option>
                <option value="Data Science">Data Science</option>
                <option value="ai">Intelligenza Artificiale</option>
                <option value="Python">Python and Machine Learning</option>
                <option value="Game Developer">Game Developer</option>
                <option value="Ux-Ui">UX/UI Design</option>
                <option value="DigitalMktg">Digital Marketing</option>
                <option value="SocialMedia">Social Media Management</option> */}
                <option value="pm">Project Management</option>
                <option value="BIM">BIM & Autocad</option>
                <option value="amministrativi">Lavori Amministrativi</option>
                <option value="Interior Design">Interior Design</option>
                {/* <option value="Graphic Design">Graphic Design</option>
                <option value="Video Editing">Video Editing</option> */}
              </select>
            </div>
             <div className='domanda'>
                <label>Perchè stai cercando un corso di formazione?</label>
                <select 
                id='category-select'
                className={`${necessità !== "" ? 'filled' : missingField.includes("Categorie") ? 'campo-mancante' : ''}`} 
                value={necessità} 
                onChange={(e) => handleChange(e, setNecessità)} required>
                    <option disabled value="">Seleziona una motivazione</option>
                    <option value="Sono alla ricerca di lavoro">Sono alla ricerca di lavoro</option>
                    <option value="Voglio cambiare lavoro">Voglio cambiare lavoro</option>
                    <option value="Ho bisogno di una certificazione">Ho bisogno di una certificazione</option>
                    <option value="Voglio aumentare il mio stipendio">Voglio aumentare il mio stipendio</option>
                    <option value="Interesse personale">Interesse personale</option>
                    <option value="Altro">Altro</option>
                </select>
            </div>

      
        
            <div className='domanda domanda-prezzo'>
                <label style={{maxWidth: '330px', width: '100%'}}>Fino a quanto sei disposto a spendere?</label>
                {/*subjectOfInterest !== "" ? (
                <select 
                className={`${budget !== "" ? 'filled' : ''}`} 
                value={budget} 
                onChange={(e) => {handleChange(e, setBudget); handleChange(e, setOrigBudget)}} required>
                    <option disabled value="">Seleziona un costo</option>
                    {uniquePrice && uniquePrice.map((data, index) => (
                        <option key={index} value={data}>
                            {data}
                        </option>
                    ))}
                </select>
                ) : (
                <select 
                disabled
                className={`${budget !== "" ? 'filled' : ''}`} 
                value={budget} 
                onChange={(e) => handleChange(e, setBudget)} required>
                    <option disabled value="">Seleziona un costo</option>
                </select>                    
                )*/}
                <PrezziSlider min={prezzoMin} max={6000} step={500} onChange={handleChangePrezzo} rangeMax={prezzoMax} />
            </div>
            
            
            
         
            <div className='domanda domanda-input'>
                <label>Nome</label>
                <input
                id='name-input'
                required
                className={`${firstName !== "" ? 'filled' : missingField.includes("Nome") ? 'campo-mancante' : ''}`}
                type="text"
                value={firstName}
                onChange={(e) => handleChange(e, setFirstName)}
                />
            </div>
            <div className='domanda domanda-input'>
                <label>Cognome</label>
                <input
                id='surname-input'
                required
                className={`${lastName !== "" ? 'filled' : missingField.includes("Cognome") ? 'campo-mancante' : ''}`}
                type="text"
                value={lastName}
                onChange={(e) => handleChange(e, setLastName)}
                />
            </div>
               <div className='domanda'>
                <label>Quanti anni hai?</label>
                <select 
                id='available-time-select' style={{ width: '100%'}}
                className={`${categories !== "" ? 'filled' : missingField.includes("Età") ? 'campo-mancante' : ''}`} 
                value={categories} 
                onChange={(e) => handleChange(e, setCategories)} required>
                    <option disabled value="">Seleziona</option>
                    <option value="17-24">17-24 anni</option>
                    <option value="25-30">25-30 anni</option>
                    <option value="31-40">31-40 anni</option>
                    <option value="41-55">41-55 anni</option>
                    <option value="Oltre 55">Oltre 55 anni</option>
                </select>
            </div>

              <div className='domanda domanda-autocomplete domanda-input'>
                <label>In quale <b>provincia</b> vivi?</label>
                <AutocompleteCustom
                    id='new-province-autocomplete'
                    items={filteredProvinces}
                    value={città}
                    onChange={handleChangeProvincia}
                    onSelect={(val) => setCittà(val)}
                  />
               
            </div>
           
            <div className='domanda domanda-input'>
                <label>Email</label>
                <input
                id='email-input'
                required
                className={`${email !== "" ? 'filled' : missingField.includes("Email") ? 'campo-mancante' : ''}`}
                type="email"
                value={email}
                onChange={(e) => handleChange(e, setEmail)}
                />
            </div>
            <div className='domanda domanda-input'>
                <label>Telefono (valido per il codice di verifica)</label>
                <input
                id='phone-input'
                required
                className={`${phone !== "" ? 'filled' : missingField.includes("Numero di telefono") ? 'campo-mancante' : ''}`}
                type="tel"
                value={phone}
                onChange={(e) => handleChange(e, setPhone)}
                />
            </div>
            <div className='domanda-checkbox'>
                <input
                id='privacy-checkbox'
                type='checkbox'
                required
                value={accept}
                onChange={() => setAccept(!accept)}
                className={!accept && missingField.includes("Accetta i termini e le condizioni") ? 'campo-mancante-checkbox' : ''}
                />
                <label>
                Ho preso visione della <a href='https://www.comparacorsi.it/privacy-policy/'>Privacy Policy</a>.
                </label>
            </div>
            <div className='domanda-checkbox' style={{textAlign: 'left', display: 'flex', justifyContent:'center', gap: '0.4rem', paddingLeft: '12px'}}>
                <input
                id='data-processing-checkbox'
                type='checkbox'
                required
                value={acceptTreatment}
                onChange={() => setAcceptTreatment(!acceptTreatment)}
                className={!accept && missingField.includes("Accetta i termini e le condizioni") ? 'campo-mancante-checkbox' : ''}
                />
                <label style={{textAlign: 'left'}}>
                Ho preso visione dei <a href='https://www.iubenda.com/termini-e-condizioni/62720878'>Termini e Condizioni.</a>
                </label>
            </div>
        </div>
        {!isLoad ? 
        <button id='comparatore-old-discover-courses-btn' onClick={handleSubmit} className='button-prosegui'>Scopri tutti i corsi <FaArrowRight /></button> : 
        <button className='button-prosegui'>Invio in corso..</button>
        }
        <p className='p-under-btn'>Verrai contattato da un nostro operatore</p>
        <div className='comparatore-bottom'>
            <h2>
            <b>Compariamo corsi online</b>, e lo facciamo <font color='#FF692D'>bene</font>.
            </h2>
            <p>
            {showFullText ? (
                <>
                  Siamo il primo comparatore di corsi online in Italia. Il nostro obiettivo è quello di fare chiarezza nel mare di offerte formative che trovi in rete: mettiamo a confronto i migliori enti di istruzione telematici e le <b>università telematiche</b> per aiutarti a scegliere l’opzione adatta alle tue esigenze. 
                  Grazie a ComparaCorsi puoi valutare le caratteristiche delle migliori realtà formative italiane online, tra cui: corsi triennali, corsi magistrali, corsi a ciclo unico, corsi post laurea, corsi professionalizzanti, corsi di perfezionamento, corsi di preparazione ai test di ingresso e molti altri. 
                  Con ComparaCorsi, trovi in pochi minuti il percorso formativo che più si avvicina alle tue esigenze, confrontando le proposte delle principali istituzioni, enti e <b>università telematiche</b> italiane fruibili online. Il nostro servizio è gratuito e ti offre una panoramica completa delle opzioni disponibili, 
                  aiutandoti nella scelta del percorso giusto per la tua crescita personale e professionale. Se sei indeciso su quale percorso universitario seguire, la nostra sezione dedicata ai corsi triennali e magistrali ti permetterà di confrontare diversi indirizzi e specializzazioni, dandoti una chiara visione delle opportunità.
                  Se devi superare un concorso e non sai quale corso di preparazione fa al caso tuo, puoi affidarti alla sezione dedicata ai corsi per le professioni. Se vuoi perfezionare le tue competenze dopo la laurea, puoi facilmente mettere a confronto i migliori corsi post laurea e professionalizzanti. Grazie alla nostra piattaforma, 
                  rimani sempre aggiornato sulle ultime novità del mondo della formazione e puoi fare una scelta consapevole, trasparente e in linea con gli obiettivi del tuo futuro.
                </>
              ) : (
                <>
                  Siamo il primo comparatore di corsi online in Italia. Il nostro obiettivo è quello di fare chiarezza nel mare di offerte formative che trovi in rete: mettiamo a confronto i migliori enti di istruzione telematici e le <b>università telematiche</b> per aiutarti a scegliere l’opzione adatta alle tue esigenze. 
                  Grazie a ComparaCorsi puoi valutare le caratteristiche delle migliori realtà formative italiane online, tra cui: corsi triennali, corsi magistrali, corsi a ciclo unico, corsi post laurea, corsi professionalizzanti, corsi di perfezionamento, corsi di preparazione ai test di ingresso e molti altri. 
                </>
              )}
              <button onClick={() => setShowFullText(!showFullText)}>
                {showFullText ? 'Leggi meno' : 'Leggi di più'}
              </button>            
            </p>
        </div>
    </div>
  )
}

export default ComparatoreLeadSystem
